import icon from '~/assets/public/xero-icon.png';
import { Tooltip } from '~/components';
import { useIntegrations } from '~/contexts';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  width: 1rem;
  height: 1rem;
  margin-left: 0.5rem;
  cursor: pointer;
`;

const Image = styled.img`
  width: 1rem;
  height: 1rem;
`;

export default function XeroIndicator({ message, xeroCreditNoteId, xeroConnectionId }) {
  const integrations = useIntegrations();
  const xeroConnection = integrations.xero?.find((c) => c.id === xeroConnectionId);

  if (!xeroConnection) return null;

  const defaultMessage = `This credit note is in ${xeroConnection?.name || 'Xero'}.`;

  const handleClick = (event) => {
    event.stopPropagation();
    if (!xeroCreditNoteId) return;

    const creditNoteURL = xeroConnection.orgCode
      ? `https://go.xero.com/organisationlogin/default.aspx?shortcode=${xeroConnection.orgCode}&redirecturl=/AccountsReceivable/ViewCreditNote.aspx?creditNoteID=${xeroCreditNoteId}`
      : `https://go.xero.com/AccountsReceivable/ViewCreditNote.aspx?creditNoteID=${xeroCreditNoteId}`;
    return window.open(creditNoteURL, '_blank');
  };

  return (
    <Wrapper onClick={handleClick}>
      <Tooltip message={message ?? defaultMessage}>
        <Image src={icon} />
      </Tooltip>
    </Wrapper>
  );
}
